import React, { useState } from 'react';

interface ImageContentRendererProps {
  payload: {
    // Prefer backend-provided view_url for any viewing/preview, fall back to file_url for legacy data
    view_url?: string;
    file_url?: string;
    file_path?: string; // backend-internal; do not use to build URLs on FE
    alt_text?: string;
    caption?: string;
  };
  file: {
    file_id: string;
    file_name: string;
    file_type: string;
    file_size: number;
    // Prefer backend-provided view_url for any viewing/preview, fall back to file_url for legacy data
    view_url?: string;
    file_url?: string;
    file_path?: string; // backend-internal; do not use to build URLs on FE
    options: any;
  };
}

export const ImageContentRenderer: React.FC<ImageContentRendererProps> = ({ payload, file }) => {
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  if (imageError) {
    return (
      <div className="text-center">
        <div className="text-gray-500 dark:text-gray-400 mt-4">
          <div className="text-4xl mb-2">🖼️</div>
          <p>Không thể tải hình ảnh</p>
        </div>
      </div>
    );
  }

  return (
    <div className="text-center">
      <img
      src={
        file.view_url ||
        payload.view_url ||
        file.file_url ||
        payload.file_url ||
        ''
      }
        alt={payload.alt_text || 'Hình ảnh'}
        className="max-w-full h-auto rounded-lg shadow-lg mx-auto"
        onError={handleImageError}
      />
      {payload.caption && (
        <p className="text-sm text-gray-600 dark:text-gray-400 mt-2 italic">
          {payload.caption}
        </p>
      )}
    </div>
  );
};
